export const userPropertyFetch = (body, user_id) => {
	fetch(process.env.REACT_APP_ANALYTICS_SERVER_URL + 'userProps/' + user_id, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			authorization: '633cfacf-fada-42d7-a6eb-5a2ec429d314',
		},
		body: JSON.stringify(body),
	}).catch(error => {
		console.log(error)
	})
}

export const purchasePropertyFetch = (body, user_id) => {
	const reqBody = {
		...body,
		amount: +(body.amount + '').split('.').join(''),
		datetime: Date.now(),
		app_name: 'REFINE',
	}
	fetch(process.env.REACT_APP_ANALYTICS_SERVER_URL + `purchase/${user_id}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			authorization: '633cfacf-fada-42d7-a6eb-5a2ec429d314',
		},
		body: JSON.stringify(reqBody),
	}).catch(error => {
		console.log(error)
	})
}
